import { createWsConnectThunks, WsPrefixes } from '@skynet/data-ws-core';
import type { WsAuthState } from './slice';

export type AuthWsState = { wsAuth: WsAuthState };

const { wsLogout, wsDisconnect, subscribeWsData } = createWsConnectThunks({
  sliceKey: 'wsAuth',
  prefix: WsPrefixes.authPrefix,
  logoutCommand: 'Logout',
  disconnectCommand: 'Disconnect',
});

export {
  wsLogout as wsAuthLogout,
  wsDisconnect as wsAuthDisconnect,
  subscribeWsData as subscribeWsAuthData,
};
